<template>
  <div>
    <div class="card bg-cr-red-black text-white mb-3">
      <div class="d-flex flex-column-reverse flex-lg-row">
        <div class="position-relative">
          <div class="card-body pb-5">
            <h4><i class="fa fa-trophy mr-2"></i> Dé commercialcompetitie</h4>
            <p>
              Is jullie commercial de <strong>beste van het kwartaal</strong>? Op
              commercialreview.nl laten we Nederland elk kwartaal kiezen wat de best scorende
              commercials, verdeeld over zes categorieën zijn. Meld je commercial aan voor dé
              commercialcompetitie en maak elk kwartaal kans op 1 van de titels!
            </p>
            <div class="d-flex flex-column flex-md-row justify-content-center align-items-center">
              <div class="mr-0 mb-3 mr-md-3 mb-md-0">
                <a
                  class="btn btn-secondary btn-sm"
                  target="_blank"
                  href="/commercialcompetitie"
                >
                  <i class="fa fa-info-circle"></i> {{ $t('phrase.more_info') }}
                </a>
              </div>
              <div>
                <v-button
                  text="word.register*"
                  :rounded="true"
                  @click="$emit('research-type-selected', 'competition')"
                  size="lg"
                />
              </div>
            </div>
          </div>
          <div class="price-pane position-absolute p-2">
            <small>*Aanmelden kan vanaf &euro; {{ BASE_PRICES.competition }},-</small>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <img
            class="d-none d-lg-block competition-banner"
            src="@/common/assets/img/competition-540x540.jpg"
            alt="commercialreview"
          />

          <img
            class="d-block d-lg-none w-100"
            src="@/common/assets/img/competition-960x327.jpg"
            alt="commercialreview"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 mb-3">
        <v-register-commercial-card
          research-type="benchmark"
          color="info"
          title="Benchmark"
          :price="BASE_PRICES.benchmark"
          icon="pie-chart"
          @research-type-selected="$emit('research-type-selected', 'benchmark')"
        >
          <template v-slot:subtitle>
            Krijg snel <strong>inzicht</strong> in je commercial met het grondige benchmarkonderzoek
          </template>
          <template v-slot:content>
            <v-check-six-categories
              title="Benchmarking van je commercial op 6 dimensies"
            />
            <hr/>
            <v-check-commercial-questions
              commercial-type="tv"
              researchType="benchmark"
            />
            <hr/>
            <v-check-add-custom-question/>
            <hr/>
            <v-check-pdf-report/>
            <hr/>
            <v-check-number-of-reviewers/>
            <hr/>
            <v-check-commercial-dashboard/>
            <hr/>
            <v-check-csv-export/>
            <hr/>
            <v-check-commercial-promoted/>
          </template>
        </v-register-commercial-card>
      </div>
      <div class="col-md-6 mb-3">
        <v-register-commercial-card
          research-type="research"
          title="Research"
          color="success"
          :price="BASE_PRICES.research"
          icon="magnifying-glass"
          button-text="phrase.request"
          @research-type-selected="$emit('research-type-selected', 'test')"
        >
          <template v-slot:subtitle>
            Uitgebreide <strong>pre- of posttest</strong> van je marketinguiting
            (beschikbaar in Nederland, Vlaanderen & Wallonië)
          </template>
          <template v-slot:content>
            <div>
              <i class="fa fa-check text-success"></i>
              Representatieve testgroep (standaard n=100)
            </div>
            <hr/>
            <div>
              <i class="fa fa-check text-success"></i>
              Kies je eigen doelgroep op basis van leeftijd, geslacht of een andere eigenschap
            </div>
            <hr/>
            <div>
              <i class="fa fa-check text-success"></i>
              Vrijheid in het samenstellen van de vragen
            </div>
            <hr/>
            <div>
              <i class="fa fa-check text-success"></i>
              Kies je testmateriaal: afbeelding, schets, tekst, animatie, video, audio etc.
            </div>
            <hr/>
            <v-check-commercial-dashboard/>
            <hr/>
            <v-check-csv-export/>
            <hr/>
            <div>
              <i class="fa fa-check text-success"></i>
              Advies vanuit Commercialreview bij opzet en analyse
            </div>
          </template>
        </v-register-commercial-card>
      </div>
    </div>
    <v-partner-carousel/>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import PartnerCarousel from '@/common/components/carousels/PartnerCarousel.vue';
import { BASE_PRICES } from '@/common/utils/constants';
import RegisterCommercialCard from '@/common/components/registration/RegisterCommercialCard.vue';
import AddCustomQuestion from '@/common/components/registration/AddCustomQuestion.vue';
import CommercialQuestions from '@/common/components/registration/CommercialQuestions.vue';
import CommercialDashboard from '@/common/components/registration/CommercialDashboard.vue';
import CommercialPromoted from '@/common/components/registration/CommercialPromoted.vue';
import NumberOfReviewers from '@/common/components/registration/NumberOfReviewers.vue';
import PdfReport from '@/common/components/registration/PdfReport.vue';
import CheckSixCategories from '@/common/components/registration/SixCategories.vue';
import CsvExport from '@/common/components/registration/CsvExport.vue';

export default {
  name: 'RegisterCommercialStartTv',
  components: {
    'v-check-add-custom-question': AddCustomQuestion,
    'v-check-commercial-questions': CommercialQuestions,
    'v-check-commercial-dashboard': CommercialDashboard,
    'v-check-commercial-promoted': CommercialPromoted,
    'v-check-number-of-reviewers': NumberOfReviewers,
    'v-check-pdf-report': PdfReport,
    'v-check-six-categories': CheckSixCategories,
    'v-check-csv-export': CsvExport,
    'v-partner-carousel': PartnerCarousel,
    'v-register-commercial-card': RegisterCommercialCard,
    'v-button': Button,
  },
  data() {
    return {
      BASE_PRICES,
    };
  },
};
</script>

<style scoped>
.competition-banner {
  width: 270px;
  height: auto;
}

.price-pane {
  bottom: 0;
  right: 0;
}

.img-december {
  height: 25px;
  width: auto;
}
</style>
